import { types } from "util";

export const locale = {
  lang: 'en',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "Dashboard",
        BADGE: "2",
        ANALYTICS: "Analytics",
        ECOMMERCE: "E-Commerce",
        "users": "Users",
        "list": "List",
        "add": "Add",
        "ads": "Ads",
        "counselors": "Counselors",
        "stores_offers": "Stores Offers",
        "cancelation_reason": "Cancelation Reason",
        "companies": "Companies",
        "consulting": "Consulting",
        "categories": "Categories",
        "services": "Services",
        "tags": "Tags",
        "articles": "Articles",
        "offers": "Offers",
        "plantcards": "Plant Cards",
        "Settings": "Settings",
        "ShowDetails": "Show Details",
        "TermsAndConditions": "Terms & Conditions",
        "About": "About",
        "Notifications": "Notifications",
        "Currencies": "Currencies",
        "Countries": "Countries",
        "Cities": "Cities",
        "plans": "plans",
        "light": "light",
        "root": "root",
        "seed": "seed",
        "soil": "soil",
        "stem": "stem",
        "counselorspayment": "counselorspayment",
        "OpenScreens": "Open Screens",
        "GanatakCommunity": "Ganatak Community",
        "Paperform": "Paperform",
        "Sizes": "Sizes",
        "Sliders": "Sliders"
      },
      ANMAR: {
        TITLE: "Anmar",
        HOME_DETAILS: " Home",
        HOME_ABOUT: " About",
        HOME_SERVICES: " Services",
        HOME_WORK: " Work",
        HOME_BUSINESS: " Business",
        HOME_CLIENTS: " Clients",
        HOME_PARTNERS: " Partners",
        ABOUT_DATES: " Timeline",
        ABOUT_VISION: " Vision",
        ABOUT_VALUE: " Values",
        ABOUT_TEAM: " Teams",
        SERVICES_STEPS: "Services Steps",
        CONTACT_MESSAGES: " Messages",
        BLOG: "Blog",
        LIST: "List",
        ADD: "Add",
        SERVICES: "Services",
        PROJECTS: "Projects",
        COMPANY_PROFILES: "Company profiles",
        SECTIONS: "Page sections"
      },
      USERS_SECTION: "Customers",
      USERS: {
        LIST: "Users List",
        ADD: "Add User"
      },
      PRODUCTS: {
        Title: "Products",
        LIST: "Products List",
        AT_HOME: "Products at Home"
      },
      COUNSELORS: {
        Title: "Consultants",
        LIST: "Consultants List",
        ADD: "Add Consultant"
      },
      STORES: {
        Title: "Stores",
        LIST: "Stores List",
        ADD: "Add Store"
      },
      STORES_OFFERS: {
        Title: "Store Offers",
        LIST: "Offers List"
      },
      VOUCHER: {
        Title: "Promotions",
        TYPE: "Promotion Types",
        LIST: "Promotions List"
      },
      cancelation_reasons: {
        Title: "Cancellation Reason",
        LIST: "Cancellation Reasons List",
        ADD: "Add Reason"
      },
      COMPANIES: {
        Title: "Companies",
        LIST: "Companies List",
        ARCHIVED: "Archived Companies",
        ADD: "Add Company"
      },
      consulting: {
        Title: "Consulting",
        LIST: "Consulting List"
      },
      SERVICES: {
        Title: "Services",
        LIST: "Services List",
        ADD: "Add Service"
      },
      SECTION: {
        Title: "Sections",
        LIST: "Sections List",
        TYPES: "Voucher Types",
        ADD: "Add Section"
      },
      ARTICLES: {
        Title: "Articles",
        LIST: "Articles List",
        Plant_groups: "Plant Groups",
        ADD: "Add",
        various: "Various Agricultural Articles"
      },
      TAGS: {
        Title: "Tags",
        LIST: "Tags List",
        ADD: "Add Tag"
      },
      offers: {
        Title: "Offers",
        LIST: "Offers List",
        ADD: "Add Offers"
      },
      reasone_canceled: {
        Title: "Cancellation Reason",
        LIST: "List",
        ADD: "Add"
      },
      PLANTCARDS: {
        TITLE: "Plant Cards",
        LIST: "Plant Cards List",
        ADD: "Add Plant Card",
        LEAVERSCOLOR: {
          TITLE: "Leaf Colors",
          LIST: "Leaf Colors List",
          ADD: "Add Leaf Color"
        },
        LEAVERSFORM: {
          TITLE: "Leaf Shapes",
          LIST: "Leaf Shapes List",
          ADD: "Add Leaf Shape"
        },
        FLOWERFORM: {
          TITLE: "Flower Shapes",
          LIST: "Flower Shapes List",
          ADD: "Add Flower Shape"
        },
        FLOWERCOLOR: {
          TITLE: "Flower Colors",
          LIST: "Flower Colors List",
          ADD: "Add Flower Color"
        },
        ENVIRONMENTLIGHT: {
          TITLE: "Environmental Light",
          LIST: "Environmental Light List",
          ADD: "Add Environmental Light"
        },
        ENVIRONMENTTEMP: {
          TITLE: "Environmental Temperature",
          LIST: "Environmental Temperature List",
          ADD: "Add Environmental Temperature"
        },
        ENVIRONMENHUMIDITY: {
          TITLE: "Environmental Humidity",
          LIST: "Environmental Humidity List",
          ADD: "Add Environmental Humidity"
        },
        REPRODUCTIONS: {
          TITLE: "Reproduction",
          LIST: "Reproduction Methods List",
          ADD: "Add Reproduction Method"
        },
        PLANTCARDSOIL: {
          TITLE: "Soil Types",
          LIST: "Soil Types List",
          ADD: "Add Soil Type"
        }
      }
    },
    ANMAR_PAGES: {
      COMMON: {
        LIST: "List",
        ADD: "Add",
        EDIT: "Edit",
        VIEW: "View",
        DELETE: "Delete",
        SAVE: "Save",
        UPDATE: "Update",
        CANCEL: "Cancel",
        ACTIONS: "Actions",
        LOADING: "Loading...",
        NO_DATA: "No data found",
        CONFIRM_DELETE: "Are you sure you want to delete this item?",
        CREATED_SUCCESS: "Created successfully",
        UPDATED_SUCCESS: "Updated successfully",
        DELETED_SUCCESS: "Deleted successfully",
        ERROR: "Something went wrong",
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        YES: "Yes",
        NO: "No",
        SEARCH: "Search",
        SHOW: "Show",
        ENTRIES: "Entries",
        EMPTY_HELP: "Try adding a new item or changing the search text.",
        CREATE_ENTRY: "Create a new entry",
        UPDATE_ENTRY: "Update existing data",
        ARRAY_HINT: "Enter comma-separated values. They will be sent as an array.",
        REQUIRED_FIELD: "Please fill in the required fields"
      },
      FIELDS: {
        ID: "ID",
        IMAGE: "Image",
        ICON: "Icon",
        VIDEO: "Video",
        LINK: "Link",
        TITLE_AR: "Arabic Title",
        TITLE_EN: "English Title",
        DESCRIPTION_AR: "Arabic Description",
        DESCRIPTION_EN: "English Description",
        SHORT_DESCRIPTION_AR: "Short description (AR)",
        SHORT_DESCRIPTION_EN: "Short description (EN)",
        CONTENT_AR: "Arabic Content",
        CONTENT_EN: "English Content",
        NAME: "Name",
        NAME_AR: "Arabic Name",
        NAME_EN: "English Name",
        EMAIL: "Email",
        TYPE: "Type",
        ABOUT: "About",
        STATUS: "Status",
        VALUE: "Value",
        KEY: "Key",
        SLUG: "Slug",
        LOCATION_AR: "Location (AR)",
        LOCATION_EN: "Location (EN)",
        PROJECT_URL: "Project URL",
        PAGE_ID: "Page ID",
        SUBTITLE_AR: "Subtitle (AR)",
        SUBTITLE_EN: "Subtitle (EN)",
        DATE: "Date",
        YEAR: "Year",
        CATEGORY: "Category",
        CATEGORIES: "Categories",
        LANGUAGES: "Languages",
        PROGRAMMING_LANGUAGES: "Programming Languages",
        WEBSITE_URL: "Website URL",
        WEBSITE_LINK: "Website Link",
        ANDROID_LINK: "Android Link",
        IOS_LINK: "iOS Link",
        STEPS: "Steps",
        STEP: "Step",
        STEP_NUMBER: "Step Number",
        ADD_STEP: "Add Step",
        REMOVE_STEP: "Remove Step",
        STEP_TITLE_AR: "Step Title Arabic",
        STEP_TITLE_EN: "Step Title English",
        STEP_DESCRIPTION_AR: "Step Description Arabic",
        STEP_DESCRIPTION_EN: "Step Description English",
        STEPS_COUNT: "Steps Count",
        STEPS_HELP: "Add project-specific steps for this item.",
        SORT_ORDER: "Sort Order",
        IS_ACTIVE: "Is Active",
        CLIENT_NAME: "Client name",
        IS_FEATURED: "Featured project"
      },
      MODULES: {
        HOME_DETAILS: "Home Details",
        HOME_ABOUT: "Home About",
        HOME_SERVICES: "Home Services",
        HOME_WORK: "Home Work",
        HOME_BUSINESS: "Business",
        HOME_CLIENTS: "Home Clients",
        HOME_PARTNERS: "Home Partners",
        ABOUT_DATES: "About Dates",
        ABOUT_VISION: "About Vision",
        ABOUT_VALUE: "About Value",
        ABOUT_TEAM: "About Team",
        SERVICES_STEPS: "Services Steps",
        CONTACT_MESSAGES: "Contact Messages",
        BLOG: "Blog",
        SERVICES: "Services",
        PROJECTS: "Projects",
        COMPANY_PROFILES: "Company profile PDFs",
        SECTIONS: "Page sections"
      }
    }
  }
};
